var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51953 12.6499L10.9954 13.7958C11.1879 13.9883 11.6187 14.0799 11.9029 14.0799H13.7179C14.2862 14.0799 14.9095 13.6491 15.0562 13.0807L16.202 9.60654C16.4404 8.93737 16.0095 8.36906 15.2945 8.36906H13.3879C13.1037 8.36906 12.8654 8.13073 12.9112 7.80073L13.1495 6.27903C13.2412 5.8482 12.957 5.37152 12.5262 5.23402C12.1412 5.08735 11.6645 5.27984 11.4812 5.56401L9.52871 8.46988",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08984 12.6515V7.98562C7.08984 7.31645 7.374 7.07812 8.04317 7.07812H8.51984C9.18901 7.07812 9.47318 7.31645 9.47318 7.98562V12.6515C9.47318 13.3207 9.18901 13.559 8.51984 13.559H8.04317C7.374 13.559 7.08984 13.3207 7.08984 12.6515Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1719 17.2896H16.4752C15.7419 17.2896 15.0452 17.5737 14.5319 18.0871L12.9644 19.6363C12.2494 20.3421 11.0852 20.3421 10.3702 19.6363L8.8027 18.0871C8.28937 17.5737 7.58354 17.2896 6.85938 17.2896H6.17188C4.65021 17.2896 3.42188 16.0704 3.42188 14.5671V4.56622C3.42188 3.06289 4.65021 1.84375 6.17188 1.84375H17.1719C18.6935 1.84375 19.9219 3.06289 19.9219 4.56622V14.5671C19.9219 16.0613 18.6935 17.2896 17.1719 17.2896Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharity);
export default __webpack_public_path__ + "static/media/charity.0cddbf9a04a7ea88a086b25a90afb16b.svg";
export { ForwardRef as ReactComponent };